import React from 'react'
import "./styles/selectboard.css"

function AddedTask() {
  return (
    <div className='ss'>
        <div className='addedtask-container'>
            <p>Task updated successfully</p>
        </div>
    </div>
  )
}

export default AddedTask